import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "./App.css"

import Navbar from './components/Navbar';
import NotFound from './pages/NotFound';
import NewsDetail from './pages/NewsDetail';
import Location from './pages/Location';
import Home from './pages/Home';
import ScrollToTop from './components/ScrollToTop';
import GroupIntroduction from './pages/GroupIntroduction';
import Values from './pages/Values';
import News from './pages/News';
import Sale from './pages/sale';
import CarListing from './pages/CarListing';
import ChatBot from './components/ChatBot';
import Statistic from './pages/statistic';
import Video from './components/Video';
import About from './pages/About';
import VisionMission from './pages/VisionMission';
import Gallery from './pages/Gallery';
import Gallery2 from './pages/Gallery2';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Video />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about/values" element={<Values />} />
        <Route path='/about/introduction' element={<GroupIntroduction />} />
        <Route path="/news-information/news" element={<News />} />
        <Route path="/news-information/statistic" element={<Statistic />} />
        <Route path="/aBlock" element={<Gallery />} />
        <Route path="/bBlock" element={<Gallery2 />} />
        <Route path="/listing/:id" element={<Sale />} />
        <Route path="/listing" element={<CarListing />} />
        <Route path="/location" element={<Location />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/history" element={<About />} />
        <Route path="/vision-mission" element={<VisionMission />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ChatBot />
    </Router>
  );
};

export default App;
